export default Object.freeze({
  0: 'All emails',
  1: 'Limited',
  2: 'Invoicing only',
  All: 0,
  Limited: 1,
  Invoicing: 2
});
